import Integrations from '../components/modules/integrations';
import Courier from '../components/modules/courier-dashboard';

const Integration = [
  {
    path: '/integrations',
    name: 'integrations',
    component: Integrations,
    meta: {
      title: 'Integrations',
      tlabel: 'INDENT_INTEGRATION_HEADER',
    },
  },
  {
    path: '/courier',
    name: 'courier',
    component: Courier,
    meta: {
      title: 'Courier',
      feature: 'view_courier_integrations',
    },
  },
];
export default Integration;
